import * as React from 'react'
import {SpriteName} from 'airship/patterns/types'
import SvgSprite from 'airship/patterns/svg-sprite'
import * as analytics from 'airship/modules/track'

interface Props {
  url: string
  title: string
  description?: string
  spriteName?: SpriteName
  seleniumTarget?: string
  onClick?: (e: React.MouseEvent) => void
}

const MessageType: React.FC<Props> = ({
  url,
  onClick,
  seleniumTarget,
  spriteName,
  title,
  description
}) => {
  return (
    <a
      className="card u-size-fill u-pad-1 u-flex u-flex-align-items-center"
      href={url}
      onClick={e => {
        if (onClick) onClick(e)
        analytics.track('Composer', 'Click', 'Create Message Type', {
          messageType: title.toLowerCase()
        })
      }}
      data-selenium-target={seleniumTarget || ''}
    >
      <div>
        {spriteName ? (
          <SvgSprite
            name={spriteName}
            displayClasses="u-text-grow-8 u-space-right-06"
          />
        ) : (
          <svg className="dm-icon" />
        )}
      </div>
      <div className="u-text-bold u-black u-text-shrink-1">
        {title}
        <div className="u-block u-text-regular u-text-shrink-2 u-grey-80">
          {description}
        </div>
      </div>
    </a>
  )
}

export default MessageType
